export default __webpack_public_path__ + "static/media/StripeLogo.7f45ba8f.svg";